import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';
import { cancelOnboarding, deleteOnboarding } from '../../../data/store/onboarding/onboardingActions';

const ModalDeleteOnboarding = ({deleteModal, setDeleteModal, userId}) => {
  const {id, cancel} = deleteModal;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleCloseDelModal = () => {
    setDeleteModal(null);
  };

  const submitDelete = () => {
    if(cancel) {
      dispatch(cancelOnboarding({id, accountId: userId}));
    } else {
      dispatch(deleteOnboarding({id, accountId: userId}));
    }
    handleCloseDelModal();
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={deleteModal}
      onCancel={handleCloseDelModal}
      centered
      footer={null}
      zIndex={1600}
    >
      <Row justify="start">
        <Col className="modal-title">
          {t(cancel ? 'MODAL_CANCEL_TITLE' : 'MODAL_DELETE_TITLE')}
        </Col>
      </Row>
      <Divider className="modal-divider" />
      <Row justify="start" className="modal-text-wrapper">
        <Col>
          <p className="modal-description">
            {t(cancel ? 'MODAL_CENCELED_ONBOARDING' : 'MODAL_DELETE_ONBOARDING')}
          </p>
          <p className="modal-name">{id}</p>
        </Col>
      </Row>
      <Row justify="end" style={{ marginTop: '50px' }}>
        <Col>
          <Button
            className="modal-action-btn cancel-btn"
            onClick={handleCloseDelModal}
          >
            {t('CANCEL')}
          </Button>
          <Button
            style={{ marginLeft: '8px' }}
            className="modal-action-btn delete-btn"
            onClick={submitDelete}
          >
            {t(cancel ? 'CONFIRM' : 'DELETE')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalDeleteOnboarding;

ModalDeleteOnboarding.propTypes = {
  deleteModal: PropTypes.object,
  setDeleteModal: PropTypes.func,
  userId: PropTypes.string,
};
